var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loan-list',{attrs:{"filter":"Purchasing","title":_vm.$t('menu.purchasingLoan')}})}
var staticRenderFns = []

export { render, staticRenderFns }